<template>
  <md-card-content>
    <md-table class="paginated-table table-striped table-hover">
      <md-table-head>ID</md-table-head>
      <md-table-head>{{ $t("Name") }}</md-table-head>
      <md-table-head>{{ $t("Edit") }}</md-table-head>
      <md-table-toolbar style="padding: 0 0 20px 0;">
        <md-field>
          <md-button
            class="md-raised md-primary"
            @click="showProjectEditor(-1)"
          >
            {{ $t("Add") }}
          </md-button>
        </md-field>
      </md-table-toolbar>
      <md-table-row v-for="(item, position) in projects" :key="position">
        <md-table-cell md-label="ID">{{ position + 1 }}</md-table-cell>
        <md-table-cell :md-label="$t('Name')">
          {{ item.name }}
        </md-table-cell>
        <md-table-cell>
          <md-button
            class="md-just-icon md-simple md-primary"
            @click="showProjectEditor(position)"
          >
            <md-icon>create</md-icon>
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>
  </md-card-content>
</template>

<script>
export default {
  props: {
    projects: {
      type: Array,
      required: true
    }
  },
  methods: {
    showProjectEditor(position) {
      this.$emit("showProjectEditor", position);
    }
  }
};
</script>
